var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiamondClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "6 2 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 42C18.4767 36.3416 11.745 29.6098 6 22C11.745 14.3901 18.4767 7.65842 26 2C33.5233 7.65842 40.255 14.3901 46 22C40.255 29.6098 33.5233 36.3416 26 42V42Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3 15.71C31.91 15.32 31.28 15.32 30.89 15.71L26 20.59L21.11 15.7C20.72 15.31 20.09 15.31 19.7 15.7C19.31 16.09 19.31 16.72 19.7 17.11L24.59 22L19.7 26.89C19.31 27.28 19.31 27.91 19.7 28.3C20.09 28.69 20.72 28.69 21.11 28.3L26 23.41L30.89 28.3C31.28 28.69 31.91 28.69 32.3 28.3C32.69 27.91 32.69 27.28 32.3 26.89L27.41 22L32.3 17.11C32.68 16.73 32.68 16.09 32.3 15.71Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondClose);
export default __webpack_public_path__ + "static/media/diamondClose.22cc877337554a8b17a768e3825eb278.svg";
export { ForwardRef as ReactComponent };